export const normalizeThemeMode = (mode) => (mode === 'light' ? 'light' : 'dark');

const isColorKey = (key) => key.toLowerCase().includes('color');

export const getThemeColorKey = (key, mode) => {
  const safeMode = normalizeThemeMode(mode);
  return safeMode === 'light' ? `${key}Light` : key;
};

export const getThemeColorValue = (obj, key, mode, fallback) => {
  if (!obj) return fallback;
  const safeMode = normalizeThemeMode(mode);

  if (safeMode === 'light') {
    const lightKey = `${key}Light`;
    const lightVal = obj[lightKey];
    if (lightVal !== undefined && lightVal !== null && lightVal !== '') return lightVal;
  }

  const baseVal = obj[key];
  if (baseVal !== undefined && baseVal !== null && baseVal !== '') return baseVal;

  return fallback;
};

export const resolveThemeColors = (value, mode) => {
  const safeMode = normalizeThemeMode(mode);
  if (safeMode !== 'light') return value;

  const resolve = (input) => {
    if (!input || typeof input !== 'object') return input;

    if (Array.isArray(input)) {
      let next = null;
      for (let i = 0; i < input.length; i += 1) {
        const item = input[i];
        if (item && typeof item === 'object') {
          const resolved = resolve(item);
          if (resolved !== item) {
            if (!next) next = input.slice(0, i);
            next[i] = resolved;
          } else if (next) {
            next[i] = item;
          }
        } else if (next) {
          next[i] = item;
        }
      }
      return next || input;
    }

    let next = null;
    const entries = Object.entries(input);

    for (const [k, v] of entries) {
      const resolvedVal = resolve(v);
      if (resolvedVal !== v) {
        if (!next) next = { ...input };
        next[k] = resolvedVal;
      }
    }

    for (const [k, v] of entries) {
      if (!k.endsWith('Light')) continue;
      const baseKey = k.slice(0, -5);
      if (!baseKey || !isColorKey(baseKey)) continue;
      if (v === undefined || v === null || v === '') continue;

      const resolvedVal = resolve(v);
      const target = next || input;
      if (target[baseKey] !== resolvedVal) {
        if (!next) next = { ...input };
        next[baseKey] = resolvedVal;
      }
    }

    return next || input;
  };

  return resolve(value);
};
